import React from 'react';
import PropTypes from 'prop-types';
import SummaryContainer from "./../containers/SummaryContainer";
import TargetPositionContainer from "./../containers/TargetPositionContainer";
import NameContainer from "./../containers/NameContainer";
import EmailContainer from "./../containers/EmailContainer";
import RetypeEmailContainer from "./../containers/RetypeEmailContainer";
import CountryContainer from "./../containers/CountryContainer";
import PhoneContainer from "./../containers/PhoneContainer";
import PaymentMethodContainer from "./../containers/PaymentMethodContainer";
import {hintTippyInitByClass} from "../../hint-tippy/hint-tippy";

class PersonalInfo extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        hintTippyInitByClass(document.querySelectorAll('.hint-tippy'));
    }

    render() {

        const onBackToOrderDetailsClick = this.props.onBackToOrderDetailsClick

        return (
            <div className="personal-info__wrp">
                <a className="button button__edit-order" id="back-to-order-details-btn" onClick={onBackToOrderDetailsClick}>
                    <svg width="14" height="7" viewBox="0 0 14 7">
                        <defs>
                            <path id="7781a" d="M140 144.29l4.3-3.3.7.72-2.98 2.29H154v1h-11.98l2.99 2.29-.72.71-4.3-3.3.21-.2z"/>
                        </defs>
                        <g>
                            <g
                                transform="translate(-140 -141)"
                                dangerouslySetInnerHTML={{__html: '<use fill="#bcbcbc" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#7781a" />' }}>
                            </g>
                        </g>
                    </svg>
                    <span>Back</span>


                </a>
                <div className="page__title">About you</div>
                <div className="row">
                    <div className="col-lg-8">
                        <div className="order-form__part formpart formblock">
                            <div id="personal_info" className="order_table">


                                    <div className="personal-info__wrp_w">
                                        <div className="page__secured-fields hint hint-tippy" title="Your personal information is protected by 256-bit encryption. We will never share your personal information with writers or/and any third parties">
                                            Your personal information is secured
                                        </div>
                                        <TargetPositionContainer />
                                        <NameContainer />
                                        <div className="personal-info__item email-row">
                                            <EmailContainer />
                                            <RetypeEmailContainer />
                                        </div>
                                        <div className="country-row personal-info__item">
                                            <CountryContainer />
                                            <PhoneContainer />
                                        </div>
                                        <PaymentMethodContainer />
                                    </div>

                            </div>
                            <div className="thankyou-footer">
                            </div>
                        </div>

                    </div>
                    <div className="col-lg-4">
                        <div className="price-wrp">
                            <SummaryContainer />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

PersonalInfo.propTypes = {
    onBackToOrderDetailsClick: PropTypes.func
};

export default PersonalInfo;